module.exports = __webpack_public_path__ + "static/media/birthday_mug.7738bcec.jpg";